import axios from 'axios';

const API_BASE_URL = 'https://api4.sstli.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Interceptor للإضافة أي headers
api.interceptors.request.use(
  (config) => {
    // يمكنك إضافة token هنا لو محتاج
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const databaseAPI = {
  // جلب كل الجداول
  getAllTables: () => api.get('/DatabaseInfo/tables'),
  
  // جلب معلومات جدول معين
  getTableInfo: (schema, tableName) => 
    api.get(`/DatabaseInfo/table-info/${schema}/${tableName}`),
  
  // جلب بيانات جدول مع pagination
  getTableData: (schema, tableName, params) => 
    api.get(`/DatabaseInfo/table-data/${schema}/${tableName}`, { params }),
  
  // جلب عينة من البيانات
  getTableSample: (schema, tableName) => 
    api.get(`/DatabaseInfo/table-data-sample/${schema}/${tableName}`),
  
  // جلب كل البيانات (بحد)
  getAllTableData: (schema, tableName, limit = 1000) => 
    api.get(`/DatabaseInfo/table-data-all/${schema}/${tableName}?limit=${limit}`),
  
  // جدديث قاعدة البيانات
  refreshDatabase: () => api.get('/DatabaseInfo/tables'),
};

export default api;